import React from "react";
import DashboardLayout from "../layout";
import Header from "../header/Header";
import IorCalculatorForm from "./IorCalculatorForm";
import IorTermsPopup from "./IorTermsPopup";
import { useMyContext } from "../../context/MyContext";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "../../lib/setting";

const IorCalculatorPage = () => {
    const { user, updateUserProfile } = useMyContext();

    // Fetch settings
    const { data: settingsData, isLoading: settingsLoading } = useQuery(
        ["settings"],
        getSettings,
        {
            refetchOnWindowFocus: false,
        }
    );

    return (
        <DashboardLayout>
            <div className="w-full border border-red">
                <Header title="One Union TradeOS™" />
                <div className="min-h-[100vh] w-full flex items-center justify-center">
                    <div className="w-full h-full max-w-[80vw]">
                        <IorCalculatorForm
                            settingsData={settingsData}
                            settingsLoading={settingsLoading}
                        />
                    </div>
                </div>
            </div>

            <IorTermsPopup />
        </DashboardLayout>
    );
};

export default IorCalculatorPage;
